
import { Options, Vue } from 'vue-class-component';
import { PropType } from "vue";
import Popper from 'vue3-popper';
import CourseService from "@/services/CourseService";
import RegionService from "@/services/RegionService";
import { Course, CourseEnrollment } from "@/data/course";
import NavigationService from "@/services/NavigationService";
import CourseActions from "@/components/CourseActions.vue";
import CourseSpecialInfo from "@/components/CourseSpecialInfo.vue";
import { formatTime } from "@/utils/helpers";

@Options({
    props: {
        course: {
            type: Object as PropType<Course>,
            required: true,
        },
        userCourseEnrollments: {
            type: Array,
            required: true,
        },
        loadingEnrollments: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        Popper,
        CourseActions,
        CourseSpecialInfo,
    },
    methods: {
        formatTime,
    },
    emits: [
        'enrollmentStatusChange',
    ],
})
export default class RegionCoursesCard extends Vue {
    course!: Course
    userCourseEnrollments!: CourseEnrollment[]

    loadingEnrollments!: boolean

    get description() {
        return this.course.info_text || this.course.course_type.description || null;
    }

    get descriptionLines() {
        if( !this.description ) {
            return [];
        }

        return this.description.split("\n");
    }

    onEnrollmentStatusChange() {
        this.$emit('enrollmentStatusChange');
    }

    //mounted() {}
}
